import React from 'react';
import { FaFacebookF, FaGithub, FaLinkedin } from "react-icons/fa";;

const SocialMedia = () => {
    return (
        <div className='mb-8'>
            <div className='flex justify-center mt-5'>
                <a href="https://www.facebook.com/profile.php?id=100006375407675" target='_blank' rel="noreferrer" className='btn mx-5 text-2xl'> <FaFacebookF></FaFacebookF> </a>
                <a href="https://www.linkedin.com/in/meraz07/" target='_blank' rel="noreferrer" className='btn mx-5 text-2xl'> <FaLinkedin></FaLinkedin> </a>
                <a href="https://github.com/Miraz9907" target='_blank' rel="noreferrer" className='btn mx-5 text-2xl'> <FaGithub></FaGithub> </a>
                </div>
        </div>
    );
};

export default SocialMedia;